define(['jquery', 'jquery.transit', 'modernizr', 'container', 'load-more', 'lightbox', 'slider', 'preloader', 'underscore'],
    function ($, transit, modernizr, container, loadMoreFactory, lightboxFactory, sliderFactory, preloader, _) {

        return (function () {

            const name = 'module-gallery';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const loadMore = loadMoreFactory.create();
            const lightbox = lightboxFactory.create();
            const slider = sliderFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {
                getLightboxGalleryItems: (id) => {
                    $.ajax({
                        url: model.publicVars.ajaxGetLightboxGalleryEndpoint,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {
                        pubSub.publish('view/actionGetLightboxItems', { data: data, id: id });
                    });
                }
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                isSliderInit: false,
                loadingSliderItemsState: false,
                loadingSliderItemsNewId: null,
                gallerySize: {
                    width: 932,
                    height: 524
                },
            };

            view.startup = function () {
                preloader.init();
                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.getCurrentLoadMoreParams);

                // if($(window).width() < 600) {
                //     $(view.publicVars.cssId.galleryItemInitWrapperCls).remove();
                //     loadMore.overrideOffsetLimit(8, 8);
                // }

                lightbox.init(view.publicVars.lightboxSetup);
                lightbox.setCloseCallback(view.methods.onLightboxClose);

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);
            };

            view.bind = function () {
                $(view.publicVars.cssId.galleryWrapperCls).on('click', view.publicVars.cssId.galleryItemCls,function () {

                    const id = container.getData($(this)[0], 'id');

                    $('html').addClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.galleryLightboxLoaderId).css({ display: 'block'});
                    $(view.publicVars.cssId.galleryLightboxSlideCls).css({ display: 'none'});
                    $(view.publicVars.cssId.galleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    view.methods.calculateLightboxSize(view.privateVars.gallerySize.width, view.privateVars.gallerySize.height);

                    lightbox.showLayer(() => {

                        container.trackInteraction('show gallery click', {
                            'subsection': 'series|gallery',
                            'contenttype': 'gallery',
                            'contenttitle': 'gallery item: ' + id
                        });

                        view.methods.sliderShowInit(id);
                    });
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gallerySize.width, view.privateVars.gallerySize.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gallerySize.width, view.privateVars.gallerySize.height);
                    }
                });
            };

            view.methods = {

                getCurrentLoadMoreParams: () => {
                    return view.publicVars.loadMoreAdditionalParams;
                },
                sliderShowInit: (id) => {

                    //$(view.publicVars.cssId.galleryLightboxSlideCls + id).css({ display: 'block'});

                    if(!view.privateVars.loadingSliderItemsState) {

                        view.privateVars.loadingSliderItemsNewId = null;

                        if (!view.privateVars.isSliderInit) {
                            view.privateVars.isSliderInit = true;
                            view.privateVars.loadingSliderItemsState = true;
                            model.methods.getLightboxGalleryItems(id);
                        } else {
                            slider.setCurrentItem(id);
                            view.methods.sliderShow(id);
                        }
                    } else {
                        view.privateVars.loadingSliderItemsNewId = id;
                    }

                },

                actionGetLightboxItems: (action, res) => {

                    view.privateVars.loadingSliderItemsState = false;

                    let id = res.id;

                    if(view.privateVars.loadingSliderItemsNewId !== null) {
                        id = parseInt(view.privateVars.loadingSliderItemsNewId);
                        view.privateVars.loadingSliderItemsNewId = null;
                    }

                    view.publicVars.sliderSetup.currentItem = id;

                    const compiled = _.template($(view.publicVars.cssId.galleryLightboxItemTemplateId).html());

                    const output = compiled({
                        data: res.data
                    });

                    $(view.publicVars.cssId.galleryLightboxSliderCls).html(output);

                    slider.init(view.publicVars.sliderSetup);

                    view.methods.sliderShow(id);
                },

                sliderShow: (id) => {
                    $(view.publicVars.cssId.galleryLightboxSlideCls).css({ display: 'none'});

                    const imgSrc = container.getData($(view.publicVars.cssId.galleryLightboxSlideCls + id)[0], 'img.src');

                    preloader.preloadSingleImage('slider-init', imgSrc, () => {
                        $(view.publicVars.cssId.galleryLightboxSlideImgCls, view.publicVars.cssId.galleryLightboxSlideCls + id).attr('src', imgSrc);
                        $(view.publicVars.cssId.galleryLightboxCls).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));
                        $(view.publicVars.cssId.galleryLightboxLoaderId).transit({ opacity: 0 }, 300, () => {
                            $(view.publicVars.cssId.galleryLightboxLoaderId).removeAttr('style');
                            $(view.publicVars.cssId.galleryLightboxLoaderId).css({ display: 'none'});
                        });

                        $(view.publicVars.cssId.galleryLightboxSlideCls + id).css({ display: 'block'});
                        $(view.publicVars.cssId.galleryLightboxSliderCls).transit({ opacity: 1}, 300);
                    });
                },

                onLightboxClose: () => {
                    $('html').removeClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.galleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));
                    $(view.publicVars.cssId.galleryLightboxLoaderId).css({ display: 'block'});

                    $(view.publicVars.cssId.galleryLightboxSliderCls).css({ opacity: 0});
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.galleryLightboxAreaCls).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.galleryLightboxAreaCls).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.galleryLightboxAreaCls).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.galleryLightboxAreaCls).css('padding-right'));

                    const border = parseInt($(view.publicVars.cssId.galleryLightboxAreaCls).css('border-width'));

                    const maxWidth = windowWidth - paddingLeft - paddingRight - border - border;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - border - border;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.gallerySize.width;
                    let adjustedHeight = view.privateVars.gallerySize.height;

                    if (width !== '' && height !== '' && parseInt(width) > 400 && parseInt(height) > 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + border + border;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + border + border;

                    $(view.publicVars.cssId.galleryLightboxAreaCls)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                },
            };

            /* custom events */
            pubSub.subscribe('view/actionGetLightboxItems', view.methods.actionGetLightboxItems);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
